// extracted by mini-css-extract-plugin
export default {"buttons":"FeedbackCenter_buttons__66Xcp","select":"FeedbackCenter_select__J0aJK","link":"FeedbackCenter_link__Nm-E9","nonlink":"FeedbackCenter_nonlink__UwS4n"};